<template>
    <div>
        <BrandForm
            name="company"
            :item=brand
            type="brands"
            :products="products"
            :collab="collab"
            @create="createBrand"
            @update="updateBrand"
        />
        <BrandList
            :items=brands
            type="brands"
            @edit-item=selectedItem
        />
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
    import BrandList from "@/components/BrandList";
    import BrandForm from "@/components/BrandForm";

    export default {
        name: "AdminBrands",
        components: {
            BrandList,
            BrandForm
        },
        created() {
            this.getBrands()
        },
        data() {
            return {
                brand: {
                    _id: null,
                    name: "",
                    website: "",
                    logo: ""
                },
                products: [],
                collab: [],
            }
        },
        methods: {
            ...mapActions('brand', ['createBrand', 'updateBrand', 'getBrands', 'getBrandProducts', 'getCollaboratorsProducts']),
            selectedItem(i){
                this.brand = i;
                this.getBrandProducts(i).then((data) => {
                    this.products = data.products;
                });
                this.getCollaboratorsProducts(i).then((data) => {
                    this.collab = data.products;
                });
            }
        },
        computed: {
            ...mapGetters('brand', [
                'brands'
            ])
        }
    }
</script>

<style scoped lang="scss">
    .input-group{
        display: flex;
        justify-content: space-between;
        position: relative;
        border-radius: 3px;
        padding: 0;

        input[type="file"]{
            height: auto;
            padding: 8px 3px 3px 10px;
        }

        .green-btn{
            margin: 0;
        }

    }

    .brand-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        margin-top: 20px;
        padding-left: 40px;

        .brand-item{
            position: relative;
            width: 250px;
            margin: 5px;
            border: 2px solid var(--main-green);
            border-radius: 5px;
            padding: 5px 0;
            text-align: center;

            .close-btn{
                font-size: 8px;
                position: absolute;
                color: #fff;
                z-index: 9
            }

            .logo{
                display: inline-block;
                width: 30px;
                height: 30px;
                margin: 5px auto;
                border: 1px solid #bbb;
                border-radius: 50%;
                overflow: hidden;
                vertical-align: middle;

                img{
                    width: 100%;
                }
            }

            p{
                display: inline-block;
                margin: 2px;
                height: 32px;
            }

            .actions{
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;

                .green-btn{
                    font-size: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 35px;
                    width: 35px;
                    margin: auto;
                    padding: 0;
                    border-radius: 50%;
                    text-decoration: none;
                }
            }
        }
    }
</style>
